import axios from "./api";
const baseUrl = "/business/user";
const User = {
  add(user) {
    return axios.post(`${baseUrl}`, user);
  },
  update(user, id) {
    return axios.put(`${baseUrl}/${id}`, user);
  },
  getAll(query=null) {
    return axios.get(`${baseUrl}?${query ? query : ""}`);
  },
  getById(id) {
    return axios.get(`${baseUrl}/${id}`);
  },
  updateLocation(locationId){
    return axios.post(`${baseUrl}/update-location`, { location_id: locationId })
  },
  deleteUser(id) {
    return axios.delete(`${baseUrl}/${id}`);
  },
  getStripeCustomerDetails(customerId, locationId){
    return axios.get(`/business/stripe-customer/${customerId}/${locationId}`);
  }
};

export default User;
